module.exports = __webpack_public_path__ + "static/media/twin-milwaukee-eight.e9c68f81.jpg";